var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.364,
    height: 31.876,
    viewBox: "0 0 24.364 31.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546",
    transform: "translate(-13.681 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M37.609,24.377,36.1,22.531a7.779,7.779,0,0,1-1.745-4.865V14.244a8.526,8.526,0,0,0-6.677-8.321V4.312a1.812,1.812,0,1,0-3.624,0v1.61a8.5,8.5,0,0,0-6.677,8.321v3.422a7.588,7.588,0,0,1-1.745,4.865l-1.51,1.845a1.977,1.977,0,0,0,1.51,3.221H36.066a1.979,1.979,0,0,0,1.543-3.219Z",
    fill: "#0055af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M41.362,88.862A4.353,4.353,0,0,0,45.724,84.5H37a4.353,4.353,0,0,0,4.362,4.362Z",
    transform: "translate(-15.496 -54.486)",
    fill: "#0055af"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9c5841827e0e81cef706aabbd9d895c6.svg";
export { ForwardRef as ReactComponent };